<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.terms_of_service'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="h-screen">
            <iframe
                :title="$t('messages.terms_of_service')"
                class="w-full h-full"
                :src="meta.links.terms_of_service"
            ></iframe>
        </div>
    </PanelPage>
</template>

<script>
import RegisterLayout from '@/Shared/RegisterLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: RegisterLayout,
    name: 'Index',
    props: ['meta', 'options'],
    data() {
        return {};
    },
};
</script>
